<script>
	import { onMount } from 'svelte'
	import { fade, fly } from 'svelte/transition'

	const { $: jQuery } = window

	let shown = false
	let person = {
		//false
		img: '',
		title: 'Manager',
		name: 'John',
		body: 'description',
	}

	let html

	const closePopup = () => {
		html.classList.remove('show-modal')
		shown = false
	}
	const wrapClick = e => e.target === e.currentTarget && closePopup()

	onMount(() => {
		html = document.getElementsByTagName('html')[0]
		jQuery('.team > div').on('click', e => {
			person = jQuery(e.currentTarget).data('member')
			html.classList.add('show-modal')
			shown = true
		})
	})
</script>

<style type="text/scss">
	.main {
		align-self: center;
		width: unset;
		height: 100%;
		margin: auto;
	}
</style>

<svelte:window on:keyup={e => e.keyCode === 27 && closePopup()} />

{#if shown && person}
	<div
		class="team-popup-wrap"
		on:click={wrapClick}
		transition:fade={{ duration: 300 }}>
		<div class="main" on:click={wrapClick}>
			<div class="inner-wrap" in:fly={{ y: 15 }} out:fly={{ y: -15 }}>
				<div class="team-popup">
					<!-- person info -->
					<div class="popup-inner">
						<div class="tp-row">
							<div class="tp-img">
								<div style={`background-image:url(${person.img})`} />
							</div>
							<div class="tp-content">
								<h2>{person.name}</h2>
								<h4 class="tp-title">{person.position}</h4>
								<div>
									{@html person.content}
								</div>
							</div>
						</div>
					</div>
				</div>
				<button class="close-popup" on:click={closePopup}>
					<span>&times;</span>
				</button>
			</div>
		</div>
	</div>
{/if}
